import { ERoomType, IJsonQuery } from '@cian/api-models/common/json_query';
import { Checkbox } from '../Checkbox';
import { Outside } from '@cian/ui-kit';
import { mergeStyles } from '@cian/utils';
import * as React from 'react';
import * as R from 'ramda';

import { COMMON_ROOM_TYPE_NAMES, SPECIAL_ROOM_TYPE_NAMES } from '../../constants/roomType';
import { offerTypeFromJsonQuery, FOfferType } from '../../utils/category';
import { setTerm } from '../../utils/jsonQuery';
import { getRoomTypeLabel } from '../../utils/roomType';
import * as stylesCommon from '../FiltersCommon/FiltersCommon.css';
import * as styles from './FilterRoomType.css';

export interface IFilterRoomTypeProps {
  value: ERoomType[];
  onSelect(roomType: ERoomType): void;
}

export interface IFilterRoomTypeState {
  active: boolean;
}

const COMMON_ROOM_TYPES: { label: string; value: ERoomType }[] = [
  { label: COMMON_ROOM_TYPE_NAMES[ERoomType.FlatOneRoom], value: ERoomType.FlatOneRoom },
  { label: COMMON_ROOM_TYPE_NAMES[ERoomType.FlatTwoRooms], value: ERoomType.FlatTwoRooms },
  { label: COMMON_ROOM_TYPE_NAMES[ERoomType.FlatThreeRooms], value: ERoomType.FlatThreeRooms },
  { label: COMMON_ROOM_TYPE_NAMES[ERoomType.FlatFourRooms], value: ERoomType.FlatFourRooms },
  { label: COMMON_ROOM_TYPE_NAMES[ERoomType.FlatFiveRooms], value: ERoomType.FlatFiveRooms },
  { label: COMMON_ROOM_TYPE_NAMES[ERoomType.FlatManyRooms], value: ERoomType.FlatManyRooms },
];

const SPECIAL_ROOM_TYPES: { label: string; value: ERoomType }[] = [
  { label: SPECIAL_ROOM_TYPE_NAMES[ERoomType.Studio], value: ERoomType.Studio },
  { label: SPECIAL_ROOM_TYPE_NAMES[ERoomType.FlatFreeLayout], value: ERoomType.FlatFreeLayout },
];

export class FilterRoomType extends React.Component<IFilterRoomTypeProps, IFilterRoomTypeState> {
  public state: IFilterRoomTypeState = {
    active: false,
  };

  public render() {
    const { value } = this.props;
    const { active } = this.state;

    const roomTypeLabel = getRoomTypeLabel(value);

    return (
      <Outside onOutside={this.handleOutsideClick}>
        <div {...mergeStyles(stylesCommon['container'], styles['container'])} data-mark="FilterRoomsCount">
          <button
            {...mergeStyles(
              stylesCommon['button'],
              active && stylesCommon['button--active'],
              !roomTypeLabel && stylesCommon['button--empty'],
            )}
            title={roomTypeLabel || undefined}
            onClick={this.handleButtonClick}
          >
            {roomTypeLabel || 'Комнат'}
          </button>
          {active && (
            <div className={styles['dropdown']}>
              <ul className={styles['list']}>
                {COMMON_ROOM_TYPES.map(item => (
                  <li key={`item_${item.label}`}>
                    <button
                      {...mergeStyles(styles['button'], value.includes(item.value) && styles['button--active'])}
                      onClick={() => this.handleRoomTypeSelect(item.value)}
                    >
                      {item.label}
                    </button>
                  </li>
                ))}
              </ul>
              <ul className={styles['list-other']}>
                {SPECIAL_ROOM_TYPES.map(item => (
                  <li key={`item_${item.label}`}>
                    <Checkbox
                      label={item.label}
                      checked={value.includes(item.value)}
                      onChange={() => this.handleRoomTypeSelect(item.value)}
                    />
                  </li>
                ))}
              </ul>
            </div>
          )}
        </div>
      </Outside>
    );
  }

  private handleButtonClick = () => {
    this.setState(state => ({
      active: !state.active,
    }));
  };

  private handleOutsideClick = () => {
    this.setState({
      active: false,
    });
  };

  private handleRoomTypeSelect = (roomType: ERoomType) => {
    this.props.onSelect(roomType);
  };
}

export const clear = (jsonQuery: IJsonQuery): IJsonQuery => {
  const nextOfferType = offerTypeFromJsonQuery(jsonQuery);

  let nextJsonQuery = R.clone(jsonQuery);

  if ((nextOfferType & (FOfferType.Room | FOfferType.FlatShared | FOfferType.Bed)) === 0) {
    nextJsonQuery = setTerm('room')(nextJsonQuery)(undefined);
  }

  return nextJsonQuery;
};
